var path = 'src/app/components/general-ledger/accounts/gl-accounts.template.html';
var html = "<gl-account-list detail-link=\"#!/general-ledger/accounts\"></gl-account-list>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;